<div class="fn-ui-favorite-icon">
    <button mat-icon-button class="favorite-button">
        <app-fn-ui-icon class="favorite-icon"
                        [ngClass]="{'active' : isFavorite}"
                        [icon]="isFavorite ? 'star' : 'star_outline'" size="20px"
                        [title]="title | translate">
        </app-fn-ui-icon>
    </button>
</div>
